<template>
  <div>
    <md-card class="card-container">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="'標籤類別列表'"></page-title>
        </div>
        <div class="md-layout-item float-right">
          <md-button class="md-raised md-primary float-right" @click="$router.push('/tag-group/add')">新增標籤類別</md-button>
        </div>
      </div>
      <div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>標籤類別名稱</label>
              <md-input v-model="data.name"></md-input>
            </md-field>
          </div>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised" @click="clearAll">清除搜尋結果</md-button>
        </div>
        <div class="md-layout-item">
          <md-button class="md-raised md-primary float-right" @click="getTagGroups()">搜尋</md-button>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-table>
            <md-table-row>
              <md-table-head>名稱</md-table-head>
              <md-table-head>標籤</md-table-head>
            </md-table-row>
            <md-table-row v-for="(tagGroup, index) in tagGroups" :tagGroups="tagGroups" :key="tagGroup.id">
              <md-table-cell>
                <router-link :to="`/tag-group/${tagGroup.id}/list`" v-bind:style="{backgroundColor: `#${tagGroup.color}`}">
                  {{tagGroup.name}}
                </router-link>
              </md-table-cell>
              <md-table-cell>
                <div class="tag-list">
                  <div v-for="tag in tagGroup.tag.slice(0, 9)">
                    {{tag.name}}
                  </div>
                  <div v-if="tagGroup.tag.length > 4">
                    未完
                  </div>
                </div>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>
      <div class="md-layout md-gutter md-alignment-center-center paginate-container">
        <div class="md-layout-item md-size-100">
          <paginate
            :page-count="Math.ceil(pageCount / 20)"
            :click-handler="getTagGroups"
            :prev-text="'前頁'"
            :next-text="'下頁'"
             :container-class="'pagination'"
             :no-li-surround="true"
            >
          </paginate>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import urls from '@/urls'
import axios from 'axios'
import Paginate from 'vuejs-paginate'

export default {
  data () {
    return {
      pageCount: 0,
      data: {
        name: null
      },
      tagGroups: []
    }
  },
  components: {
    PageTitle, Paginate
  },
  created () {
    this.getTagGroups()
  },
  methods: {
    clearAll: async function () {
      this.tagGroups = []
      this.data.name = null
    },
    getTagGroups: async function (page = 1) {
      for (var i in this.data) {
        if (this.data[i] === '') {
          this.data[i] = null
        }
      }
      let req = await axios.get(urls({route: 'tag-group'}), {params: {...this.data, page}})
      this.tagGroups = req.data.data
      this.pageCount = req.data.count
    }
  }
}
</script>

<style>
.tag-list > div {
  display: contents;
}
</style>



// WEBPACK FOOTER //
// src/components/TagGroup/TagGroupList.vue